import {
    CircularProgress, FormControl,
    FormControlLabel, Radio, RadioGroup,Dialog,Button
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import upiImg from "../../assets/iposub/upi.svg";
import BackButton from "../../components/common/BackButton";
import { useGlobalSpinnerActionsContext } from "../../components/loader/useloader";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import { getClientIp } from "../../helperFunctions/helperFunctions";
import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";
import './css/IPOBiding.css';
import IPOCommonBiding, { prettyPrice } from "./IPOCommonBiding";
import IPOShowDetails from "./IPOCommonDetails";
import IPODpClientID from "./IPODpClientID";
import infoIcon from '../../assets/Refer/information1.svg';




const IPOModify = ({
    nextStep,
    prevStep,
    ipoDetails,
    bidingDetail,
    goToPage
}) => {
    // console.log(ipoDetails)
    // console.log(bidingDetail)
    if(ipoDetails.Indetails){
        ipoDetails = ipoDetails.Indetails
    }

    const biddingDetails = ipoDetails?.BidingDetails
    const existingBids = biddingDetails?.bids

    const [modify, setmodify] = useState(false)

    const client_id = biddingDetails?.client_id

    const [folioCreatedSetValue, setfolioCreatedSetValue] = useState(client_id)
    const [isSubmitting,setSubmitting] = useState(false)

    const [deletedBids,setDeletedBids] = useState([])

    useEffect(() => {
        if(ipoDetails.BidingDetails){
            setmodify(true)
            //dispay UPI
            setupiValue(ipoDetails.BidingDetails.upi);
            setfolioCreatedSetValue(ipoDetails.BidingDetails.client_id);
            setcreatedFolio(ipoDetails.BidingDetails.client_id);

            setacceptTermsandconditions(true)
           
            if(ipoDetails.BidingDetails.dpid != ""){
                // folioCreatedSetValue = ipoDetails.BidingDetails.client_id;
               

                // folioCreatedSetValue = ipoDetails.BidingDetails.dpid +ipoDetails.BidingDetails.client_id
            }else {
                // folioCreatedSetValue = ipoDetails.BidingDetails.client_id
            }
            
        }

    }, []);
    let retailers = [];
    for(let i=0;i<ipoDetails.Indetails.Categories.length;i++){
        retailers.push(ipoDetails.Indetails.Categories[i])
    }
    const contextapi = useContext(Context);
    const showAlert = useNotificationActionsContext();
    
    const [createdFolio, setcreatedFolio] = useState();
    const handleInvestorSelection = (that) => {
        setshowInverror('')
        setcreatedFolio(that);
    }
    const setGlobalSpinner = useGlobalSpinnerActionsContext();
    //    const[state, setState] = useState(
    //      {
    //         id:'',
    //         newList:[],
    //         price:'',
    //         name:'',
    //         total:0,
    //         quantity:0,
    //         clickable: false

    //      });

  
    const [bidDetails, setbidDetails] = useState(bidingDetail);


    const highestBid = bidDetails.reduce(function (prev, current) {
        return ((+prev.cart.quantity * +prev.cart.price) > (+current.cart.quantity * +current.cart.price)) ? prev : current
    })
    const totalBiddingAmount =  Number(highestBid.cart.quantity) * Number(highestBid.cart.price)
    const totalShares = bidDetails.reduce(function (total, current) {
        return total + Number(current.cart.quantity) 
    },0)
    
    const stepBack = () => {
        goToPage(1)
        // prevStep();
    }
    const viewSummary = () => {
        goToPage(3)
    }

    const [selectionType, setselectionType] = useState(retailers[0].cat_desc);
    const [selectionTypeCatBrand, setselectionTypeCatBrand] = useState(retailers[0].bid_category_code);
    const toggleTab = (that, alldetails) => {
        setselectionType(that)
        setselectionTypeCatBrand(alldetails.bid_category_code)
    }

    const [acceptTermsandconditions, setacceptTermsandconditions] = useState(false)

    const updateTerms = (e) =>{
        const checked = e.target.checked
        setacceptTermsandconditions(checked)
        if(checked){
            setTermsError('')
        }
    }
    const [termsError, setTermsError] = useState('');
    const [showUPIerror, setshowUPIerror] = useState('');
    const [showInverror, setshowInverror] = useState('');
    let jsonDataAsperAPIS= [];
    const goTOPlaceorder = () =>{
        
        let alltrue = true;
        setTermsError('')
        setshowUPIerror('');

        var useData = contextapi.getSession("userData");
        console.log(useData)
        if(!upiValue){
            alltrue = false;
            setshowUPIerror('Please provide a UPI ID.')
        }
        // If at least one of the bids has price error
        if(bidDetails.some(b => !!b.price_error)){
            alltrue = false
        }
         if(acceptTermsandconditions == false){
          
            alltrue = false;
            setTermsError('Please accept Terms and Conditions')
           
        }
        console.log(createdFolio)
        if(createdFolio == undefined){   
            alltrue = false;
            setshowInverror("Please select one Investor")
        }
        if(acceptTermsandconditions == false){
            
            alltrue = false;
            setTermsError('Please accept Terms and Conditions')
           
        }
        
        if(alltrue == false){
                //
        }else {
            setSubmitting(true)
            if(modify){
                
                for(let i=0;i<bidDetails.length;i++){
                    console.log(bidDetails)
                    const existingBid = bidDetails[i]

                    // if(existingBid?.can_modify_flag == 'N'){
                    //     continue
                    // }

                    const data = {
                        "old_quantity":     existingBid.quantity,
                        "old_price":        existingBid.price,
                        "quantity":       existingBid.cart.quantity,
                        "price":          existingBid.cart.price,
                    }

                    const isNewBid = !existingBid.can_modify_flag
                    if(isNewBid){
                        delete data.old_price
                        delete data.old_quantity
                    }

                    const unChanged = (+data.quantity == +data.old_quantity && +data.price == +data.old_price)
                    // console.log(unChanged,data)

                    let action_flag = isNewBid ? 'N' : 'M' 

        
                    if(unChanged || existingBid?.can_modify_flag == 'N'){
                        action_flag = ''
                    }

                    jsonDataAsperAPIS.push({
                        "bid_no":           existingBid.bid_no || "0",
                        "bid_refno":        existingBid.kfin_refno,
                        "bid_flag":         existingBid.bid_flag,
                        "old_cutoff_flag":  existingBid.cutoff_flag,
                        "cutoff_flag":    existingBid.cutoffprice == true?"Y":'N',
                        
                        ...data,

                        "action_flag":  action_flag,
                    })
                }

                for(let i=0;i<deletedBids.length;i++){
                    console.log(`%c deletedBids == `,'color:green')
                    
                    console.log(deletedBids)
                    const existingBid =  deletedBids[i]
                    if(existingBid?.can_cancel_flag == 'N' ){
                        continue
                    }
                    jsonDataAsperAPIS.push({
                        "bid_no":           existingBid.bid_no,
                        "bid_refno":        existingBid.kfin_refno,
                        "bid_flag":         existingBid.bid_flag,
                        "action_flag":       'C',
                        "old_quantity":     existingBid.quantity,
                        "old_cutoff_flag":  existingBid.cutoff_flag,
                        "old_price":        existingBid.price,
                        "quantity":         existingBid.cart.quantity,
                        "cutoff_flag":      existingBid.cutoffprice == true?"Y":'N',
                        "price":            existingBid.cart.price
                    })
                }

                // if(jsonDataAsperAPIS.length > 0)
                {
                    setTimeout(()=>{
                                modifyTransaction();
                    },1500);
                }
                
            }else {
            
                for(let i=0;i<bidDetails.length;i++){
                    console.log(bidDetails)
                    jsonDataAsperAPIS.push({
                        "quantity":bidDetails[i].cart.quantity,
                        "cutoff_flag":bidDetails[i].cutoffprice == true?"Y":'N',
                        "price": bidDetails[i].cart.price
                    })
                }
                if(jsonDataAsperAPIS.length > 0){
                    setTimeout(()=>{
                        saveBidTransaction();
                        
                    
                        
                    },1500);
                
                }

            }
           
                
        }
    }

  function validateUPI(e){
        const text = e.target.value
        var regex = /^[\w.-]+@[\w.-]+$/

        const isValid = regex.test(text)
        if(!isValid){
            setshowUPIerror('Please enter a valid UPI ID.')
        }else{
            setshowUPIerror('')
        }
  }

  //API to update first time Transaction
  const saveBidTransaction = async (data) => {

    var useData = contextapi.getSession("userData");
    // var url = configData.baseURLProxy;
    let url = configData.baseURLDev + "/nse/addtransaction"
    console.log(data);
    var postobjt = {
        "user_key":useData.user_key,
        "agent_id": "",
        "symbol": ipoDetails.Symbol,
        "category": selectionTypeCatBrand,
        "pan": useData.pan,
        "depository": "N",
        "folio":createdFolio,
        "name": useData.name,
        "upi":upiValue,
        "noof_bids": bidDetails.length,
        "user_ip": await getClientIp(),
        "bid_details":jsonDataAsperAPIS
        // [
        //     {
        //         "quantity":"150",
        //         "cutoff_flag":"N",
        //         "price":"280"
        //     },
        // ]
      
      
    
    };
    await contextapi
      .postApiAuthCalling(url, postobjt, false)
      .then((res) => {
        console.log(res);
        console.log(postobjt);
        let ipoDetailsLoc =ipoDetails.Indetails;
        ipoDetailsLoc.APIList = postobjt
        
        ipoDetailsLoc.appl_no = res?.[0]?.appl_no
        ipoDetailsLoc.reference_no = res?.[0]?.reference_no

        // let summaJson = {
        //     apisReq: postobjt,
        //     innerdetails: ipoDetails
        // }
        
        
        if (res[0].status_code === "00") {
          var cseData = res.data;
          goToPage(4,ipoDetailsLoc);
        //   showAlert({ val: true, msg: 'Success' });
        } else {
          showAlert({ val: true, msg: `Error: ${res[0].status_desc}` });
        }
      })
      .catch((error) => {
        console.error(error)
        showAlert({ val: true, msg: 'Error occured!' });
        console.log(postobjt);
        setGlobalSpinner(false);
      }).finally(()=>{
          setSubmitting(false)
      });
  };

  //Modify cancel API
  
  const modifyTransaction = async () => {

    var useData = contextapi.getSession("userData");
    let url = configData.baseURLDev + "/nse/modifytransaction"

 

    console.log(postobjt)
    console.log(ipoDetails.BidingDetails.bids)
    console.log(ipoDetails.BidingDetails.bids[0])

    var postobjt = {
       

        "user_key":useData.user_key,
        "agent_id": "",
        "symbol": ipoDetails.Symbol,
        // "category": selectionTypeCatBrand,
        // "pan": useData.pan,
        // "depository": "N",
        // "folio":createdFolio,
        // "name": useData.name,
        // "upi":upiValue,
        "noof_bids": bidDetails.length+ deletedBids.length,
        "user_ip": await getClientIp(),

        "appl_refno": ipoDetails.BidingDetails.appl_refno,
        "appl_no": ipoDetails.BidingDetails.appl_no,

        "bid_details":jsonDataAsperAPIS
    };
    contextapi
      .postApiAuthCalling(url, postobjt, false)
      .then((res) => {
        console.log(res);
        console.log(postobjt);
        let ipoDetailsLoc =ipoDetails.Indetails;
        ipoDetailsLoc.APIList = postobjt
        // let summaJson = {
        //     apisReq: postobjt,
        //     innerdetails: ipoDetails
        // }

        if (res[0].status_code === "00") {
          var cseData = res.data;
          goToPage(4,ipoDetailsLoc);
        //   showAlert({ val: true, msg: 'Success!' });
            setDeletedBids([])  

        } else {
          showAlert({ val: true, msg: `Error: ${res[0].status_desc}` });
        }
      })
      .catch((error) => {
          console.error(error)
        showAlert({ val: true, msg: 'Error occured!' });
        console.log(postobjt);
        setGlobalSpinner(false);
      }).finally(()=>{
        setSubmitting(false)
      });
  };

    // const handleChange = (event) => {
    //     const phoneNumberPattern = new RegExp(/^\d+$/);
    //     if (
    //         event === "" ||
    //       phoneNumberPattern.test(event)
    //     ) {

    //     }
    //   };




    const addBidhere = () => {
        let createId = bidDetails.sort((a, b) => {
            return b.id - a.id
        });
        console.log(createId)
        console.log(ipoDetails)
        let json = {
            id: (Number(createId[0].id) + 1),
            lotsize: 2,
            cutoffprice: false,
            price: ipoDetails.MaxPrice,
            orderId: '',
            selectstatus: false,
           
            cart: {
                price: ipoDetails.MaxPrice,
                quantity: ipoDetails.LotSize,
                finalPrice:ipoDetails.MaxPrice,
                incBlock: false,
                decBlock: true
            }

        }
        setbidDetails([...bidDetails, json]);
    }

    const updatesetbidDetailshere = (that) =>{
        setbidDetails(that)
    }
 

    const [upiValue, setupiValue] = useState('')
    const updateUpi = (e) =>{
        setupiValue(e.target.value)
    }

    const isModify = !!modify

    return (
        <div>
            <div className="col-lg-12 col-md-12 col-12 addmargin">
                <h5 className='transactionheader'>
                    {isModify ? 
                        `MODIFY IPO ORDER`    
                        :
                        `IPO PLACE ORDER`
                }
                    
                
                </h5>
                <p className="transactionheader_desc">The following content shows the details of an IPO</p>

                <BackButton />
            </div>

            <div className="IPOCard-List">
                <div className="row makerel">



                    <div className="graphTopflex d-flex gap-4">

                        {!!biddingDetails &&                  
                            <>
                                <div className="">
                                    <p className="mb-1" style={{fontWeight:'500'}}>
                                        PAN
                                    </p>
                                    <p className="mb-1">
                                        {biddingDetails?.pan}
                                    </p>
                                </div>
                                <div className="">
                                    <p className="mb-1" style={{fontWeight:'500'}}>
                                        DPID
                                    </p>
                                    <p className="mb-1">
                                        {biddingDetails?.dpid}
                                    </p>
                                </div>
                                <div className="me-auto">
                                    <p className="mb-1" style={{fontWeight:'500'}}>
                                        Application no
                                    </p>
                                    <p className="mb-1">
                                        {biddingDetails?.appl_no}
                                    </p>
                                </div>
                            </>
                        }

                        {/* <div className="indivgraph">
                            <CircularProgressbar
                                value="90"
                                // minValue={30,384}
                                // maxValue={60.384}
                                text={`/`}
                                className="ProgressBar"
                                styles={buildStyles({
                                    // rotation:0.25,
                                    pathTransitionDuration: 1,

                                    pathColor: "#11269229",
                                    trailColor: "#FDFDFE"




                                })}
                            />
                            <div className="graphInnerbox">
                                <p className="labelingrapgsummary">Total Share</p>
                                <p className="valueingraphsummary">{totalShares}</p>
                            </div>
                        </div>

                        <div className="indivgraph">
                            <CircularProgressbar
                                value="90"
                                // minValue={30,384}
                                // maxValue={60.384}
                                text={`/`}
                                className="ProgressBar"
                                styles={buildStyles({
                                    // rotation:0.25,
                                    pathTransitionDuration: 1,
                                    pathColor: "#3A57E8",
                                    trailColor: "#FDFDFE"
                                })}
                            />
                            <div className="graphInnerbox">
                                <p className="labelingrapgsummary">Total Investment (₹)</p>
                                <p className="valueingraphsummary">{totalBiddingAmount}</p>
                            </div>
                        </div>
 */}


                    </div>

                    <div className="makeMargin">


                        <div className="row ">
                           <IPOShowDetails ipoDetails={ipoDetails} viewSummarFunc={viewSummary}/>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails extmargin">
                                <p className="primaryBrandcolor marginZero">Retail investors can purchase applications upto Rs. 2 lakhs</p>

                                <div className="addmargindematSearch ">
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            className="radiowrapperSwitch"
                                            row
                                            aria-label="gender"
                                            name="row-radio-buttons-group"
                                            value={selectionType}

                                        >
                                            {
                                            retailers && retailers.map((item, index) => {
                                                return (
                                                    <FormControlLabel key={index}
                                                    className={selectionType == item.cat_desc ? "RadiodivSwitch radioptionSwitch borderradio " : "RadiodivSwitch radioptionSwitch"}
    
                                                    value={item.cat_desc}
                                                    control={<Radio className="colorchange" />}
                                                    onChange={() => toggleTab(item.cat_desc, item)}
                                                    label={item.cat_desc}
    
                                                />
                                                );

                                            })}

                                           
                                            {/* <FormControlLabel
                                                className={selectionType === 'Investor' ? "RadiodivSwitch radioptionSwitch borderradio " : "RadiodivSwitch radioptionSwitch"}

                                                value="Investor"
                                                control={<Radio className="colorchange" />}
                                                onChange={() => toggleTab('Investor')}
                                                label="Investor"

                                            />
                                            <FormControlLabel
                                                className={selectionType === 'Employee' ? "RadiodivSwitch radioptionSwitch borderradio " : "RadiodivSwitch radioptionSwitch"}

                                                value="Employee"
                                                control={<Radio className="colorchange" />}
                                                onChange={() => toggleTab('Employee')}
                                                label="Employee"

                                            /> */}

                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                  <IPOCommonBiding bidDetails={bidDetails} updatesetbidDetails={updatesetbidDetailshere}
                   ipoDetails={ipoDetails} bidingReason="modify"
                   isModify={isModify}
                   selectionType={selectionType}
                   onDeleteBid={
                       bid => {
                            setDeletedBids([...deletedBids,bid])
                       }
                   }
                  />

                    <div className="row margintopbottom">


                        <div className="col-lg-6 col-md-6 col-12 ">
                            <IPODpClientID  
                               value={folioCreatedSetValue}
                               sendCreatedFolio={handleInvestorSelection}
                            />
                            
                            {
                                showInverror != "" &&
                                <p className="txt-red">{showInverror}</p>
                            }
                        </div>

                        <div className="col-lg-4 col-md-6 col-12 ">
                        </div>
                        <div className="col-lg-2 col-md-6 col-12 text-right margininMobile">
                            {
                                bidDetails.length < 3 &&
                                <button className="bidAddbtn" onClick={() => addBidhere()}><span>+</span>Add Bid</button>
                            }

                        </div>

                    </div>
                    <div className="row paddingzero">
                        <div className="col-lg-12 col-md-12 margiwithline">
                            <TermsAndConditionsCheck accept={acceptTermsandconditions}
                                onChange={updateTerms} termsError={termsError}
                            />
                        </div>
                        <hr className="hr" />

                        {/* <div className="row"> */}
                        <div className="col-md-7">
                            <div className="row">
                                <div className="col-md-4 col-4 mb-3 text-center rightborder">
                                    <p className="paymnrtmode">Payment Mode</p>
                                    <img src={upiImg} height="40px" width="104px" />
                                </div>
                                <div className="col-md-7 col-7">
                                    <div className="input-group custommargin">
                                        <input type="text" className="form-control" placeholder="test@okicici"
                                         aria-label="Recipient's username"
                                          aria-describedby="basic-addon2"
                                           value={upiValue} onChange={(e)=>updateUpi(e)}
                                           disabled={isModify}
                                           onBlur={validateUPI}
                                        />

                                        {/* <span className=" darkbluebg" id="basic-addon2">Verify</span> */}
                                    </div>


                                    {
                                        showUPIerror != "" &&
                                        <p className="txt-red">{showUPIerror}</p>
                                        // showUPIerrro
                                        // <p className="txt-green"><i className="fa fa-check me-1" aria-hidden="true"></i> Successfully Verified</p>
                                    }                                 </div>
                            </div>
                        </div>
                        <div className="col-md-5 custompadding">
                            <div className="row text-end">
                                <div className="col-md-6"><p className="AmountCalssname">Amount <b>₹ {prettyPrice(totalBiddingAmount)}</b></p></div>
                                <div className="col-md-6 text-endcustom">
                                <button type="button" name="button" className="clnsorde d-flex align-items-center"
                                 onClick={() => goTOPlaceorder()}
                                    disabled={!!isSubmitting}
                                > 

                                {
                                    !!isSubmitting && 
                                    <CircularProgress 
                                         size={18}
                                         style={{marginRight:'6px',color:'white'}}
                                    />
                                }
                                
                                {
                                    isModify? 'Modify':'Place'
                                }
                                {' '} Order
                                </button></div>
                            </div>
                        </div>
                        {/* </div> */}

                        {/* <div className="col-lg-12 col-md-12">
                            <div className="textRight"> <button className="clnsorde">CANCEL ORDER</button>

                            </div>

                        </div> */}

                    </div>

                </div>
                {/* <hr className="hr" /> */}
            </div>

           

        </div>
    );
}

export default IPOModify;


export const termsAndConditions =  <div className='headerName'>
<h6 className='bodyDescription px-2'>
  <img src={infoIcon} alt={'info icon'} />
  General Terms and Conditions:
</h6>

<div className="" style={{height:'60vh',overflow:'auto',backgroundColor:'whitesmoke'}}>

<h6 className='bodyDescriptionText px-2'>
1. I/We hereby confirm that I/we have read and understood the Company’s Red Herring
prospectus issued in this regard, the Issue Bid-cum-application form, disclaimers and
the Risk factors and voluntarily instruct KFin Technologies Private Limited
<span style={{fontWeight:'bold'}}>(“KFintech”)</span> to make the above Bid/ application on my/our behalf. I/We hereby
authorize KFintech to do all such acts, deeds and things, as may be necessary for or
incidental to make the above Bid/Application.
</h6>
<h6 className='bodyDescriptionText px-2'>
2. I/We hereby agree that I/we will abide by all the terms and conditions of the Issue.
I/We hereby agree that I/we shall not make multiple application(s) for the Issue.
</h6>
<h6 className='bodyDescriptionText px-2'>
3. I/We further agree that if, for any reason, KFintech is unable to block my/our said
bank account, my/our application will not be processed / sent to the Stock Exchange /
Banker/ Registrar to the Issue.
</h6>
<h6 className='bodyDescriptionText px-2'>
4.
I/We hereby agree and confirm that in case order placed by me/us gets rejected due to
technical or any other issue, if any, KFintech will not be held liable for the same and
I/we shall place a fresh order, if intend to apply in the issue.
</h6>
<h6 className='bodyDescriptionText px-2'>
5. I/We hereby agree, acknowledges and understand that the role of KFintech is only to
facilitate and process the application and KFintech shall not be responsible / liable for
any losses/damages/costs incurred in any manner.
</h6>
<h6 className='bodyDescriptionText px-2'>
6. I/We hereby agree that KFintech shall not be held responsible for non-allotment of
equity shares either fully or partly to me/us, for any reason whatsoever. I/We further
agree that KFintech shall not be held responsible if the bid/application instruction sent
by me/us is not received by it because of any reason, or if the bid/application could
not be uploaded to the Stock Exchange, or could not be sent to the Banker.
</h6>
<h6 className='bodyDescriptionText px-2'>
7. I/We hereby agree that KFintech shall not be liable for any loss that may arise from
insufficient balance in bank account or failure/inability on the part of the bank to
make available the requisite funds for any reason whatsoever.
</h6>
<h6 className='bodyDescriptionText px-2'>
8. KFintech may collect your personal information such as Name, E-mail Address, PAN
No and Mobile Number or any other information required for making the
application/bid, which shall enable KFintech to respond to your application/bid,
KFintech shall, subject to relevant law, collect, use and disclose this information to
third parties.
</h6>
<h6 className='bodyDescriptionText px-2'>
9. KFintech or its employees/directors /agents/affiliates/subsidiaries shall/ does not
advise for any kind of investments in IPO and are not liable or responsible for any
kind of investments made by you.
</h6>
<h6 className='bodyDescriptionText px-2'>
10. I/We hereby give my/our consent that KFintech can communicate with me/us via
mobile phone, messages, e-mail and any kind of online communications with respect
to my/our bid/ application.
</h6>
<h6 className='bodyDescriptionText px-2'>
11. I/We hereby agree that KFintech shall not be responsible if the performance of its
obligations is prevented, hindered or delayed by a Force Majeure event. “Force
Majeure Event” means any event due to any cause beyond the reasonable control of
KFintech, including, without limitation, unavailability of any communication system
including failure of internet links, Exchange links, sabotage, fire, flood, explosion,
earthquake, acts of God, civil commotion, pandemic, epidemic, strikes or industrial
action of any kind, riots, insurrection, war, or acts of government/regulatory bodies.
</h6>
<h6 className='bodyDescriptionText px-2'>
12. All disputes and differences arising out of, under or in connection with these terms
and conditions or anything done here under shall be within the exclusive jurisdiction
only to the courts of Hyderabad, State of Telangana, India.
</h6>
<h6 className='bodyDescriptionText px-2'>

13. I/We have fully read, understood, agree and accept the terms and conditions related to
the online application of the IPO, and do hereby agree not to question the validity,
enforceability and applicability of any provision/clauses of this document at any
circumstances whatsoever.
</h6>
</div>

</div>


export function TermsAndConditionsCheck({accept,termsError, onChange}){

    const [showTerms,setShowTerms] = useState(false)

    return <>

        {/* <button
            onClick={()=>{
            goToPage(4,{...ipoDetails.Indetails,...Bidingdetails})
            }}
        >
            Go to confirm
        </button> */}
            
        <input type="checkbox" className="acceptTermaandconditions" value={accept} 
        onChange={onChange} 
        checked={accept == true ? true : false}
        />
        <span 
            className="margiwithline_color cursor-pointer"
            onClick={()=>setShowTerms(true)}
        >
            I Accept the <u>Terms & conditions</u>
        </span>
        <br />
        {
            termsError != '' &&
            <p className="termsanccond">{termsError}</p>
        }


        <Dialog
            open={showTerms}
            onClose={()=>setShowTerms(false)}
        >

            <div className="d-flex flex-column p-4 ">


                {termsAndConditions}

                <Button
                    variant={'contained'}
                    color='primary'
                    className="ms-auto mt-3"
                    onClick={()=>{onChange({target:{checked:true}});setShowTerms(false)}}
                >
                    Agree
                </Button>
            </div>
        </Dialog>
           
    </>     

}